<template>
  <v-container>
    <div class="note" v-if="step === 0">
      <div class="my-sm-4 text-subtitle-1 font-weight-bold grey--text text--darken-2 text-center">{{$t('lang.note')}}</div>
      <div class="my-4 my-sm-4 text-subtitle-1 grey--text text--darken-1" v-html="note"></div>
      <div class="d-flex justify-space-around justify-sm-center">
        <v-row no-gutters class="d-flex justify-space-around">
          <v-col cols="12" sm="2" class="my-2">
            <v-btn class="text-body-2" block style="text-transform:none;" color="primary" @click="back(0)">{{$t('lang.back')}}</v-btn>
          </v-col>
          <v-col cols="12" sm="2" class="my-2">
            <v-btn class="text-body-2" block color="primary" style="text-transform:none;" @click="getMember()">{{$t('lang.agree')}}</v-btn>
          </v-col>
        </v-row>
        <!-- <v-btn class="mr-4" style="text-transform:none;" color="primary" @click="back(0)">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="getMember()">{{$t('lang.agree')}}</v-btn> -->
      </div>
    </div>
    <div class="member" v-if="step === 1">
      <div class="tabs-bar d-flex align-center">
        <v-tabs v-model="feeTab" center-active show-arrows grow>
          <v-tab v-for="(item, i) in feeList" :key="i" style="text-transform:none;" class="font-weight-bold text-subtitle-1 black--text" active-class="blue--text text--darken-2">
            {{$store.getters.getLanguage === 0 ? item.CostTypeName : item.CostTypeNameEnglish}}
          </v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="feeTab">
        <v-radio-group v-model="costAndatid">
          <v-tab-item v-for="(item, i) in feeList" :key="i">
          <v-col cols="12" :offset-sm="i * (12 / feeList.length)" :sm="12 / feeList.length">
            <v-radio v-if="item.IsMemberSingup === 0" :label="item.HotelFee === 0 ? item.EntryFee + $t('lang.rmb') : item.EntryFee + $t('lang.hotelExpense') + item.HotelFee + $t('lang.rmbPerson')" :value="item.CostId + ',0,' + (item.EntryFee + item.HotelFee)"></v-radio>
            <v-radio v-if="item.IsMemberSingup === 1 && item.IsEntryShow === 0" :label="item.HotelFee === 0 ? $t('lang.nonMembers') + item.EntryFee + $t('lang.rmb') : $t('lang.nonMembers') + item.EntryFee + $t('lang.hotelExpense') + item.HotelFee + $t('lang.rmbPerson')" :value="item.CostId + ',31,' + (item.EntryFee + item.HotelFee)"></v-radio>
            <v-radio v-if="item.IsMemberSingup === 1 && item.IsPersonalShow === 0" :label="item.PersonalHotelFee === 0 ? $t('lang.individualMember') + item.PersonalFee + $t('lang.rmb') : $t('lang.individualMember') + item.PersonalFee + $t('lang.hotelExpense') + item.PersonalHotelFee + $t('lang.rmbPerson')" :value="item.CostId + ',32,' + (item.PersonalFee + item.PersonalHotelFee)"></v-radio>
            <v-radio v-if="item.IsMemberSingup === 1 && item.IsTeamShow === 0" :label="item.TeamHotelFee === 0 ? $t('lang.organizationMember') + item.TeamFee + $t('lang.rmb') : $t('lang.organizationMember') + item.TeamFee + $t('lang.hotelExpense') + item.TeamHotelFee + $t('lang.rmbPerson')" :value="item.CostId + ',33,' + (item.TeamFee + item.TeamHotelFee)"></v-radio>
          </v-col>
          </v-tab-item>
        </v-radio-group>
      </v-tabs-items>
      <div class="d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="back(1)">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="VerifyTeamOrPerInfo()">{{$t('lang.next')}}</v-btn>
      </div>
    </div>
    <div class="sp" v-if="step === 2">
      <div v-if="$store.getters.getLanguage === 0">注意事项：带<span class="red--text">*</span>为必填项，请如实填写。</div>
      <div v-if="$store.getters.getLanguage === 1">Note: fields with <span class="my-auto red--text">*</span> are required, please fill in truthfully.</div>
      <v-form ref="form" class="mt-4">
        <!-- 姓名 -->
        <v-row no-gutters v-if="info.IsShowName === 0">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(info.NameTitle) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(info.NameTitle) > 10 ? 'mt-2 mb-2' : 'mt-2'">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$store.getters.getLanguage === 0 ? info.NameTitle : info.NameTitleEnglish}}</span>
          </v-col>
          <v-col cols="12" :offset-md="strCode(info.NameTitle) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-text-field v-model="name" outlined clearable required dense :rules="nameRules"></v-text-field>
          </v-col>
        </v-row>
        <!-- 电话/邮箱 -->
        <v-row no-gutters v-if="info.IsShowPhone === 0">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(info.PhoneTitle) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(info.PhoneTitle) > 10 ? 'mt-2 mb-2' : 'mt-2'">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$store.getters.getLanguage === 0 ? info.PhoneTitle : info.PhoneTitleEnglish}}</span>
          </v-col>
          <v-col cols="12" :offset-md="strCode(info.PhoneTitle) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-text-field v-model="phone" outlined clearable required dense :rules="phoneOrEmailRules"></v-text-field>
          </v-col>
        </v-row>
        <!-- 是否住宿 -->
        <v-row no-gutters v-if="info.IsShowStay === 0">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 3">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$t('lang.needHotel')}}</span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-radio-group v-model="hotelSwitch" row mandatory class="ma-0 pa-0">
              <v-radio :label="$t('lang.no1')" :value="false"></v-radio>
              <v-radio :label="$t('lang.yes1')" :value="true"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- 选择酒店 -->
        <v-row no-gutters v-if="hotelSwitch && info.IsShowStay === 0">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$t('lang.selectHotels')}}</span>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-select outlined dense v-model="hotelSelectId" :items="info.HotelList" :item-text="$store.getters.getLanguage === 0 ? 'HotelName' : 'HotelNameEnglish'" item-value="HotelId" required @change="hotelEvent()"></v-select>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2"></v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-radio-group v-if="hotelSwitch && hotelSelectId && info.IsShowRoom === 0" v-model="hotelRoomType" row>
              <v-col cols="12" sm="5" class="mt-0 pt-0">
                <v-radio :label="singleRoom"></v-radio>
              </v-col>
              <v-col cols="12" sm="5" class="mt-0 pt-0">
                <v-radio :label="standardRooms"></v-radio>
              </v-col>
            </v-radio-group>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2"></v-col>
          <v-col v-if="hotel.LinkAddress && hotelSwitch && hotelSelectId" cols="12" sm="3" class="mt-0 pt-0 pb-4">
            <v-chip color="primary" target="_blank" :href="hotel.LinkAddress ? (hotel.LinkAddress.indexOf('http://') === -1 && hotel.LinkAddress.indexOf('https://') === -1 ? 'http://' + hotel.LinkAddress : hotel.LinkAddress) : ''"><v-icon left>mdi-account-circle-outline</v-icon>{{$t('lang.reservation')}}</v-chip>
          </v-col>
        </v-row>
        <!-- 多人报名 -->
        <v-row no-gutters v-if="info.IsAllowTeamSignUp === 0 && costAndatid.split(',')[1] !== '32'">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">同一单位多人报名</span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-radio-group v-model="teamSwitch" row mandatory class="ma-0 pa-0">
              <v-radio :label="$t('lang.no1')" :value="false"></v-radio>
              <v-radio :label="$t('lang.yes1')" :value="true"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="teamSwitch && info.IsAllowTeamSignUp === 0">
          <v-col cols="12" offset-md="1" sm="5" class="mb-4">
            <v-data-table :headers="headers" :items="desserts" sort-by="num" :hide-default-header="false" :hide-default-footer="true" no-data-text="" class="elevation-1">
              <template v-slot:top>
                <v-toolbar flat>
                  <span class="my-auto red--text">*</span>
                  <span>最多{{info.TeamSignUpLimit}}人报名</span>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog
                    v-model="teamDialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="desserts.length>=info.TeamSignUpLimit"
                      >
                        增加
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form2">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.name"
                                  label="姓名"
                                  :rules="nullRules"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.phone"
                                  label="电话/邮箱"
                                  :rules="phoneOrEmailRules"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="teamClose"
                        >
                          取消
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="teamSave"
                        >
                          保存
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="teamDialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">确定要删除吗？</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="teamCloseDelete">取消</v-btn>
                        <v-btn color="blue darken-1" text @click="teamDeleteItemConfirm">确定</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  v-if="desserts.indexOf(item) !== 0"
                  small
                  class="mr-2"
                  @click="teamEditItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="desserts.indexOf(item) !== 0"
                  small
                  @click="teamDeleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- 发票信息 -->
        <v-row no-gutters v-if="info.IsAbutmentTax === 1 && info.IsShowBillInfo === 1">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">发票类型</span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-radio-group v-model="taxType" row mandatory class="ma-0 pa-0">
              <v-radio label="企业" value="1"></v-radio>
              <v-radio label="个人" value="0"></v-radio>
            </v-radio-group>
          </v-col>
          <!-- 个人发票 -->
          <v-col v-if="taxType === '0'" class="12" sm="12">
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票姓名</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxTitle" outlined clearable required dense :rules="nullRules"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票联系电话</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxPhone" outlined clearable required dense :rules="phoneRules"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票邮箱</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxEmail" outlined clearable required dense :rules="emailRules"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!-- 企业发票 -->
          <v-col v-else class="12" sm="12">
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票抬头</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxTitle" outlined clearable required dense :rules="nullRules"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">企业税号</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="enterpriseTaxNumber" outlined clearable required dense :rules="nullRules"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <!-- <span class="my-auto red--text">*</span> -->
                <span class="my-auto">企业地址</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="enterpriseAddress" outlined clearable required dense hint="请务必正确填写，如不需要不填"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <!-- <span class="my-auto red--text">*</span> -->
                <span class="my-auto">企业电话</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="enterprisePhone" outlined clearable required dense hint="请务必正确填写，如不需要不填"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <!-- <span class="my-auto red--text">*</span> -->
                <span class="my-auto">开户银行</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="enterpriseBank" outlined clearable required dense hint="请务必正确填写，如不需要不填"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <!-- <span class="my-auto red--text">*</span> -->
                <span class="my-auto">开户账号</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="enterpriseAccountNo" outlined clearable required dense hint="请务必正确填写，如不需要不填"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票联系电话</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxPhone" outlined clearable required dense :rules="phoneRules"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">发票邮箱</span>
              </v-col>
              <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-text-field v-model="taxEmail" outlined clearable required dense :rules="emailRules"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- 发票内容 -->
        <v-row no-gutters v-if="info.IsAbutmentTax === 1 && info.IsShowBillInfo === 1">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">发票内容</span>
          </v-col>
          <v-col cols="12" sm="6">
            <v-radio-group v-model="taxContentType" r2w mandatory class="ma-0 pa-0">
            <v-radio label="培训费" value="2"></v-radio>
              <v-radio label="会议费" value="0"></v-radio>
              <v-radio label="会务费" value="1"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- 发票备注 -->
        <v-row no-gutters v-if="info.IsAbutmentTax === 1 && info.IsShowBillInfo === 1">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
            <!-- <span class="my-auto red--text">*</span> -->
            <span class="my-auto">发票备注</span>
          </v-col>
          <v-col cols="12" :offset-md="0" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-text-field v-model="retreatNotes" outlined clearable required dense></v-text-field>
          </v-col>
        </v-row>
        <!-- 自定义项 -->
        <v-list>
          <v-list-item v-for="(item, i) in info.CustomItemList" :key="i" class="pa-0 d-inline">
            <!-- 文本框 -->
            <div class="text" v-if="item.ItemType === 1">
              <!-- 电话 手机 身份证 其他证件-->
              <v-row no-gutters v-if="item.ItemRule !== 1 && item.ItemRule !== 6">
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(item.ItemName) > 10 ? 'mt-2 mb-2' : 'mt-2'">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                </v-col>
                <v-col cols="12" :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                  <v-text-field v-if="item.ItemRule === 0 ||item.ItemRule === 2 || item.ItemRule === 5" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="nullRules"></v-text-field>
                  <v-text-field v-if="item.ItemRule === 3" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="phoneRules"></v-text-field>
                  <v-text-field v-if="item.ItemRule === 4" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="idsRules"></v-text-field>
                </v-col>
              </v-row>
              <!-- 日期选择 -->
              <v-row v-if="item.ItemRule === 1">
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(item.ItemName) > 10 ? 'mt-2 mb-2' : 'mt-2'">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                </v-col>
                <v-col cols="12" :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                  <v-menu v-model="info.CustomItemList[i].model" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field outlined required dense v-model="info.CustomItemList[i].Content" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="info.CustomItemList[i].Content" no-title scrollable :locale="$store.getters.getLanguage === 0 ? 'zh-CN' : 'en-US'" @input="info.CustomItemList[i].model = false">
                    </v-date-picker>
                    <!-- <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn> -->
                  </v-menu>
                </v-col>
              </v-row>
              <!-- 区域选择 -->
              <div v-if="item.ItemRule === 6">
                <v-row>
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                    <span class="my-auto red--text">*</span>
                    <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                  </v-col>
                  <v-col cols="12" sm="10">
                    <v-radio-group v-model="info.CustomItemList[i].areaSwitch" row mandatory class="ma-0 pa-0">
                      <v-radio :label="$t('lang.china')" :value="true"></v-radio>
                      <v-radio :label="$t('lang.otherCountry')" :value="false"></v-radio>
                    </v-radio-group>
                    <v-text-field v-if="!info.CustomItemList[i].areaSwitch" :placeholder="$t('lang.otherCountryName')" v-model="info.CustomItemList[i].otherCountry" outlined clearable required dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="info.CustomItemList[i].areaSwitch">
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="ma-0 pa-0">
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择省份" v-model="info.CustomItemList[i].selectProvince" outlined dense :items="info.CustomItemList[i].province" item-text="ProName" item-value="ProID" required @change="provinceEvent(info.CustomItemList[i].selectProvince)"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择城市" no-data-text="" v-model="info.CustomItemList[i].selectCity" outlined dense :items="info.CustomItemList[i].city" item-text="CityName" item-value="CityID" required @change="cityEvent(info.CustomItemList[i].selectCity)"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择区" no-data-text="" v-model="info.CustomItemList[i].selectDistrict" outlined dense :items="info.CustomItemList[i].district" item-text="DisName" item-value="Id" required @change="districtEvent(info.CustomItemList[i].selectDistrict)"></v-select>
                  </v-col>
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 5 : 4">
                    <v-text-field placeholder="详细地址" v-model="info.CustomItemList[i].detail" outlined clearable required dense></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- 文本域 -->
            <v-row v-if="item.ItemType === 2">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2">
                  <!-- <span class="my-auto red--text">*</span> -->
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-textarea name="input-7-1" outlined auto-grow v-model="info.CustomItemList[i].Content"></v-textarea>
              </v-col>
            </v-row>
            <!-- 单选 -->
            <v-row v-if="item.ItemType === 3">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" class="mt-0 pt-0">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" sm="10" class="mt-0 pt-0">
                <v-radio-group v-model="info.CustomItemList[i].Content" class="mt-0 pt-0">
                  <v-radio v-for="n in $store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" :key="n" :label="n" :value="n"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 多选 -->
            <v-row v-if="item.ItemType === 4">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" class="mt-0 pt-0">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" sm="10" class="mt-0 pt-0">
                <v-checkbox class="mt-0 " v-for="(item, n) in $store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" :key="n" :label="item" :value="item" v-model="info.CustomItemList[i].Content"></v-checkbox>
              </v-col>
            </v-row>
            <!-- 下拉 -->
            <v-row v-if="item.ItemType === 5">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(item.ItemName) > 10 ? 'mt-2 mb-2' : 'mt-2'">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-select outlined dense :items="$store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" v-model="info.CustomItemList[i].Content" required></v-select>
              </v-col>
            </v-row>
            <!-- 上传 -->
            <v-row v-if="item.ItemType === 6">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(item.ItemName) > 10 ? 'mt-2 mb-2' : 'mt-2'">
                <!-- <span class="my-auto red--text">*</span> -->
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2">
                <v-row>
                  <v-col cols="12" sm="10" v-if="info.CustomItemList[i].Content">
                    <van-image fit="cover" lazy-load height="120" width="120" :src="info.CustomItemList[i].Content"></van-image>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-file-input name="file" v-model="info.CustomItemList[i].file" accept="image/*" outlined dense prepend-icon="" prepend-inner-icon="mdi-camera" show-size placeholder="上传文件" @change="uploadImg()" ></v-file-input>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- 关联组？ -->
            <div>
            </div>
            <!-- 备注 -->
            <v-row v-if="item.ItemType === 8">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" :md="strCode(item.ItemName) > 10 ? 12 : $store.getters.getLanguage === 0 ? 1 : 2" :class="strCode(item.ItemName) > 10 ? 'mt-2 mb-2' : 'mt-2'">
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :offset-md="strCode(item.ItemName) <= 10 ? 0 : $store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10" class="mt-2">
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemOption : item.ItemOptionEnglish}}</span>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-form>
      <div v-if="totalFee !== 0" class="d-md-none d-flex justify-space-around justify-sm-center">
        <v-btn color="primary" style="text-transform:none;">参会费用合计：{{totalFee}}元</v-btn>
      </div>
      <div class="my-6 d-flex justify-space-around justify-sm-center">
        <v-btn v-if="totalFee !== 0" class="d-none d-md-flex" color="primary" style="text-transform:none;">参会费用合计：{{totalFee}}元</v-btn>
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="back(2)">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="checkPhoneOrEmail()" :loading="loading">{{$t('lang.submit')}}</v-btn>
      </div>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    <MemberVerification v-if="showMemberVerification" :id="data.SignUpId" :constId="this.costAndatid.split(',')[0]" :memberType="this.costAndatid.split(',')[1]" @verId="getVerId" @isMemberVerification="isMemberVerification"></MemberVerification>
  </v-container>
</template>

<style>
.v-data-table-header-mobile {
  display: none;
}
.v-messages__wrapper {
  color: red;
}
</style>

<script>
import MemberVerification from '@/components/MemberVerification'
import CityJson from '../utils/CityJson'
import DistrictJson from '../utils/DistrictJson'
import ProJson from '../utils/ProJson'
import utils from '../utils/utils.js'
export default {
  name: 'SignUp',
  props: ['data'],
  components: {
    MemberVerification
  },
  data: () => ({
    showMemberVerification: false,
    isNeedMemberVerification: true,
    costAndatid: null,
    feeTab: 0,
    menu: false,
    step: undefined,
    snackbar: false,
    msg: '',
    feeList: [],
    name: '',
    phone: '',
    email: '',
    nullRules: [],
    nameRules: [],
    phoneRules: [],
    phoneOrEmailRules: [],
    emailRules: [],
    idsRules: [],
    hotelSwitch: true,
    hotelSelectId: 0,
    hotelRoomType: 0,
    hotel: {},
    info: {},
    loading: false,
    verId: 0,
    showFee: false,
    teamSwitch: false,
    taxType: '1',
    teamDialog: false,
    teamDialogDelete: false,
    headers: [
      {
        text: '编号',
        align: 'start',
        value: 'num',
        sortable: false
      },
      { text: '参会人姓名', value: 'name', sortable: false },
      { text: '参会人电话/邮箱', value: 'phone', sortable: false },
      { text: '操作', value: 'actions', sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      num: '',
      name: '',
      phone: ''
    },
    defaultItem: {
      num: '',
      name: '',
      phone: ''
    },
    taxTitle: '',
    taxPhone: '',
    taxEmail: '',
    enterpriseTaxNumber: '',
    enterpriseAddress: '',
    enterprisePhone: '',
    enterpriseBank: '',
    enterpriseAccountNo: '',
    retreatNotes: '',
    taxContentType: '2'
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '新增人员' : '编辑人员'
    },
    note () {
      return this.$store.getters.getLanguage === 0 ? this.data.Notes : this.data.NotesEnglish
    },
    singleRoom () {
      return this.$store.getters.getLanguage === 0 ? '独住单间' + this.hotel.SingleRoomCount + '间' : this.hotel.SingleRoomCount + ' single rooms'
    },
    standardRooms () {
      return this.$store.getters.getLanguage === 0 ? '合住标间剩余可住人数' + this.hotel.StandardRoomCount + '人' : 'Standard rooms available for ' + this.hotel.StandardRoomCount + ' people left'
    },
    totalFee () {
      const fee = this.costAndatid.split(',')[2]
      const num = this.desserts.length
      if (parseInt(fee) === fee) {
        return fee * num
      } else {
        return Math.round((fee * num).toFixed(2) * 100) / 100
      }
    }
  },
  watch: {
    teamDialog (val) {
      val || this.teamClose()
    },
    teamDialogDelete (val) {
      val || this.teamCloseDelete()
    },
    name (val) {
      this.desserts[0].name = val
    },
    phone (val) {
      this.desserts[0].phone = val
    }
  },
  mounted () {
    if (this.data.IsNeedNotes === 1) {
      this.step = 0
    } else {
      this.getMember()
    }
    this.desserts.push({
      num: 1,
      name: this.name,
      phone: this.phone
    })
  },
  // created () {
  //   this.initialize()
  // },
  methods: {
    strCode (text) {
      return utils.methods.strCode(text)
    },
    initRoles () {
      this.nullRules = [
        v => !!v || this.$t('lang.cannotBeEmpty')
      ]
      if (this.info.IsShowName === 0) {
        this.nameRules = [
          v => !!v || (this.$store.getters.getLanguage === 0 ? this.info.NameTitle + '不能为空哦~' : this.info.NameTitleEnglish + ' cannot be empty~')
        ]
      }
      this.phoneRules = [
        v => !!v || this.$t('lang.phoneCannotBeEmpty'),
        v => (v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || this.$t('lang.correctPhone')
      ]
      this.emailRules = [
        v => !!v || this.$t('lang.emailCannotBeEmpty'),
        v => (v && /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v)) || this.$t('lang.correctEmail')
      ]
      if (this.info.IsShowPhone === 0) {
        this.phoneOrEmailRules = [
          v => !!v || (this.$store.getters.getLanguage === 0 ? this.info.PhoneTitle + '不能为空哦~' : this.info.PhoneTitleEnglish + ' cannot be empty~'),
          v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || (this.$store.getters.getLanguage === 0 ? '请输入正确的' + this.info.PhoneTitle + '哦~' : 'Please input the correct ' + this.info.PhoneTitleEnglish + '~')
        ]
      }
      this.idsRules = [
        v => !!v || this.$t('lang.idsCannotBeEmpty'),
        v => (v && /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(v)) || this.$t('lang.correctIds')
      ]
    },
    getMember () {
      this.$http.get('/SignUp/GetSignupType', {
        requestBase: 'VUE_APP_API',
        params: {
          id: this.data.Sid // QUZhZk1O可用
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res.data.data.SignUpTypeModelList)
          for (let index = 0; index < res.data.data.SignUpTypeModelList.length; index++) {
            const element = res.data.data.SignUpTypeModelList[index]
            if (element.IsMemberSingup !== 0 || element.HotelFee !== 0 || element.EntryFee !== 0) {
              this.showFee = true
              this.feeList = res.data.data.SignUpTypeModelList
              this.step = 1
              break
            }
          }
          if (!this.showFee && res.data.data.SignUpTypeModelList.length !== 0) {
            this.costAndatid = res.data.data.SignUpTypeModelList[0].CostId + ',0,0'

            this.VerifyTeamOrPerInfo()
          }
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getVerId (verId) {
      this.verId = verId
    },
    isMemberVerification (isMemberVerification) {
      this.isNeedMemberVerification = !isMemberVerification
      this.showMemberVerification = false
      if (isMemberVerification) {
        this.getSignUpInfo()
      }
    },
    VerifyTeamOrPerInfo () {
      if (!this.costAndatid) {
        this.msg = this.$store.getters.getLanguage === 0 ? '请选择参会类型' : 'Please choose  the type of participation'
        this.snackbar = true
        return
      }
      if ((this.costAndatid.split(',')[1] === '32' || this.costAndatid.split(',')[1] === '33') && this.isNeedMemberVerification) {
        this.showMemberVerification = true
      } else {
        this.getSignUpInfo()
      }
    },
    getSignUpInfo () {
      this.$http.get('/SignUp/GetSignupInfo', {
        requestBase: 'VUE_APP_API',
        params: {
          Sid: this.data.Sid,
          Atid: this.costAndatid.split(',')[1],
          CostId: this.costAndatid.split(',')[0]
        }
      }).then(res => {
        console.log(res)
        if (res.data.ret === 0) {
          this.info = res.data.data
          this.info.NameTitle = this.info.NameTitle || '姓名'
          this.info.NameTitleEnglish = this.info.NameTitleEnglish || 'Full name'
          this.info.PhoneTitle = this.info.PhoneTitle || '电话/邮箱'
          this.info.PhoneTitleEnglish = this.info.PhoneTitleEnglish || 'Email'
          if (this.info.HotelList.length !== 0) {
            this.hotelSelectId = this.info.HotelList[0].HotelId
            this.hotelEvent()
          }
          for (let index = 0; index < this.info.CustomItemList.length; index++) {
            const element = this.info.CustomItemList[index]
            if (element.ItemType === 1 && element.ItemRule === 1) {
              // this.info.CustomItemList[index].model = false
              // 添加新属性要用this.$set方法，不能直接添加
              this.$set(this.info.CustomItemList[index], 'model', false)
              this.info.CustomItemList[index].Content = new Date().toISOString().substr(0, 10)
            }
            if (element.ItemType === 4) {
              this.info.CustomItemList[index].Content = []
            }
            if (element.ItemType === 5) {
              this.info.CustomItemList[index].Content = this.$store.getters.getLanguage === 0 ? this.info.CustomItemList[index].ItemOption.split(',')[0] : this.info.CustomItemList[index].ItemOptionEnglish.split(',')[0]
            }
            if (element.ItemType === 6) {
              this.$set(this.info.CustomItemList[index], 'file', null)
            }
            if (element.ItemType === 1 && element.ItemRule === 6) {
              this.$set(this.info.CustomItemList[index], 'areaSwitch', true)
              this.$set(this.info.CustomItemList[index], 'detail', null)
              this.$set(this.info.CustomItemList[index], 'otherCountry', null)
              this.$set(this.info.CustomItemList[index], 'province', ProJson)
              this.$set(this.info.CustomItemList[index], 'city', [])
              this.$set(this.info.CustomItemList[index], 'district', [])
              this.$set(this.info.CustomItemList[index], 'selectProvince', null)
              this.$set(this.info.CustomItemList[index], 'selectCity', null)
              this.$set(this.info.CustomItemList[index], 'selectDistrict', null)
              this.$set(this.info.CustomItemList[index], 'selectProvinceName', '')
              this.$set(this.info.CustomItemList[index], 'selectCityName', '')
              this.$set(this.info.CustomItemList[index], 'selectDistrictName', '')
            }
          }
          this.initRoles()
          this.step = 2
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    back (val) {
      if (val === 0) {
        this.$emit('fatherEvent', 'back')
      } else if (val === 1) {
        if (this.data.IsNeedNotes === 1) {
          this.step = 0
        } else {
          this.$emit('fatherEvent', 'back')
        }
      } else if (val === 2) {
        if (this.showFee) {
          this.step = 1
        } else {
          if (this.data.IsNeedNotes === 1) {
            this.step = 0
          } else {
            this.$emit('fatherEvent', 'back')
          }
        }
      }
    },
    uploadImg (f) {
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.file) {
          console.info(element.file)
          const formData = new FormData()
          formData.append('files', element.file)
          this.$http({
            requestBase: 'VUE_APP_API',
            method: 'post',
            url: '/SignUp/UploadFiles',
            data: formData
          }).then(res => {
            console.log(res.data)
            if (res.data.ret === 0) {
              console.log(res.data.data)
              this.info.CustomItemList[index].file = null
              this.info.CustomItemList[index].Content = res.data.msg
            } else {
              this.msg = res.data.msg
              this.snackbar = true
            }
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    submit () {
      let custom = ''
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        const ItemName = this.$store.getters.getLanguage === 0 ? element.ItemName : element.ItemNameEnglish
        const ItemOption = this.$store.getters.getLanguage === 0 ? element.ItemOption : element.ItemOptionEnglish
        if (element.ItemType !== 8) {
          if (element.ItemType === 1 && element.ItemRule === 6) {
            if (element.areaSwitch && !(element.selectProvince && element.selectCity && element.selectDistrict && element.detail)) {
              this.msg = this.$store.getters.getLanguage === 0 ? ('请填写' + element.ItemName + '及地址') : 'Please select your ' + element.ItemNameEnglish
              this.snackbar = true
              return
            }
            if (!element.areaSwitch && !element.otherCountry) {
              this.msg = this.$store.getters.getLanguage === 0 ? '请填写' + element.ItemName : 'Please fill in your ' + element.ItemNameEnglish
              this.snackbar = true
              return
            }
            const chinaArea = element.selectProvince + ',' + element.selectCity + ',' + element.selectDistrict + 'í' +
              element.selectProvinceName + element.selectCityName + element.selectDistrictName + 'í' + element.detail + 'í中国í'
            const otherArea = '选择省份,选择城市,选择区í选择省份选择城市选择区íí其他国家í' + element.otherCountry
            const content = element.areaSwitch ? chinaArea : otherArea
            custom = custom + ItemName + '-' + element.ItemType + '-' + element.ItemRule + '-' + ItemOption + '-' +
              element.ItemProperty + '-' + content + 'ì'
          } else {
            if (element.ItemType === 3) {
              if (!element.Content) {
                this.msg = this.$store.getters.getLanguage === 0 ? '请选择' + element.ItemName : 'Please choose ' + element.ItemNameEnglish
                this.snackbar = true
                return
              }
            }
            if (element.ItemType === 4) {
              if (element.Content.length === 0) {
                this.msg = this.$store.getters.getLanguage === 0 ? '请选择' + element.ItemName : 'Please choose ' + element.ItemNameEnglish
                this.snackbar = true
                return
              }
            }
            // if (element.ItemType === 6) {
            //   if (!element.Content) {
            //     this.msg = this.$store.getters.getLanguage === 0 ? '请选择' + element.ItemName : 'Please choose ' + element.ItemNameEnglish
            //     this.snackbar = true
            //     return
            //   }
            // }
            if (element.ItemType === 1 && element.ItemRule === 1) {
              const data = element.Content.replace(/-/g, '/')
              custom = custom + ItemName + '-' + element.ItemType + '-' + element.ItemRule + '-' + ItemOption + '-' +
                element.ItemProperty + '-' + data + 'ì'
            } else {
              custom = custom + ItemName + '-' + element.ItemType + '-' + element.ItemRule + '-' + ItemOption + '-' +
                element.ItemProperty + '-' + (element.Content || '') + 'ì'
            }
          }
        }
      }
      console.log(custom)
      this.loading = true
      this.$http({
        requestBase: 'VUE_APP_API',
        method: 'post',
        url: '/SignUp/AddUserSignup',
        data: {
          SignUpId: this.data.SignUpId,
          UserName: this.name,
          Phone: this.phone,
          IsLodgings: this.hotelSwitch && this.info.IsShowStay === 0 ? 1 : 0,
          IsEat: 1,
          HotelId: this.hotelSelectId,
          HotelRoomType: this.info.IsShowRoom === 0 && this.info.IsShowStay === 0 ? this.hotelRoomType : 2,
          MemberType: this.costAndatid.split(',')[1],
          CostId: this.costAndatid.split(',')[0],
          VerId: this.verId,
          CustomContent: custom,
          MemberList: this.teamSwitch ? this.getMemberList() : null,
          TaxType: this.taxType,
          TaxTitle: this.taxTitle,
          TaxPhone: this.taxPhone,
          TaxEmail: this.taxEmail,
          EnterpriseTaxNumber: this.enterpriseTaxNumber,
          EnterpriseAddress: this.enterpriseAddress,
          EnterprisePhone: this.enterprisePhone,
          EnterpriseBank: this.enterpriseBank,
          EnterpriseAccountNo: this.enterpriseAccountNo,
          RetreatNotes: this.retreatNotes,
          TaxContentType: this.taxContentType
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.ret === 0) {
          this.generateUserSignupPayNumber(res.data.UserSignUpId, this.$store.getters.getLanguage === 0 ? res.data.msg : res.data.msg_en)
        } else {
          this.loading = false
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.loading = false
        console.log(e)
      })
    },
    generateUserSignupPayNumber (userSignUpId, msg) {
      this.$http({
        method: 'post',
        requestBase: 'VUE_APP_API',
        url: '/SignUp/GenerateUserSignupPayNumber',
        params: {
          userSignUpId: userSignUpId
        }
      }).then(res => {
        console.log(res)
        if (res.data.ret === 0) {
          // if (res.data.IsPay) {
          this.$store.commit('setTotalFee', this.costAndatid.split(',')[2])
          this.$store.commit('setLogin', false)
          this.$store.commit('setUserSignUpId', userSignUpId)
          if (res.data.PayUrlForH5) {
            this.$store.commit('setPayUrlForH5', res.data.PayUrlForH5 + '&backurl=' + this.getInvoicingLink() + '&backname=' + this.getInvoicingName())
          } else {
            this.$store.commit('setPayUrlForH5', '')
          }
          if (res.data.PayUrlForWeb) {
            this.$store.commit('setPayUrlForWeb', res.data.PayUrlForWeb + '&backurl=' + this.getInvoicingLink())
          } else {
            this.$store.commit('setPayUrlForWeb', '')
          }
          // }
          this.$emit('showDialog', msg, true)
          this.$emit('fatherEvent', 'back')
          // this.$emit('pay', 'pay')
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
        this.loading = false
      }).catch(e => {
        this.disabled = false
        console.log(e)
      })
    },
    clear () {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    },
    getInvoicingLink () {
      let url = ''
      if (this.$store.getters.getData.InvoicingLink) {
        url = this.$store.getters.getData.InvoicingLink.indexOf('http://') === -1 && this.$store.getters.getData.InvoicingLink.indexOf('https://') === -1 ? 'http://' + this.$store.getters.getData.InvoicingLink : this.$store.getters.getData.InvoicingLink
      } else {
        url = window.location.href
      }
      return encodeURIComponent(url)
    },
    getInvoicingName () {
      if (this.$store.getters.getData.InvoicingLink) {
        return encodeURIComponent('预约开票')
      } else {
        return encodeURIComponent('返回')
      }
    },
    hotelEvent () {
      for (let index = 0; index < this.info.HotelList.length; index++) {
        const element = this.info.HotelList[index]
        if (element.HotelId === this.hotelSelectId) {
          this.hotel = element
        }
      }
    },
    provinceEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectProvince === val) {
          for (let a = 0; a < ProJson.length; a++) {
            const element1 = ProJson[a]
            if (element1.ProID === element.selectProvince) {
              this.info.CustomItemList[index].selectProvinceName = element1.ProName
              break
            }
          }
          const city = []
          for (let b = 0; b < CityJson.length; b++) {
            const element2 = CityJson[b]
            if (element2.ProID === val) {
              city.push(element2)
            }
          }
          this.info.CustomItemList[index].city = city
        }
      }
    },
    cityEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectCity === val) {
          for (let a = 0; a < CityJson.length; a++) {
            const element1 = CityJson[a]
            if (element1.CityID === element.selectCity) {
              this.info.CustomItemList[index].selectCityName = element1.CityName
              break
            }
          }
          const district = []
          for (let b = 0; b < DistrictJson.length; b++) {
            const element2 = DistrictJson[b]
            if (element2.CityID === val) {
              district.push(element2)
            }
          }
          this.info.CustomItemList[index].district = district
        }
      }
    },
    districtEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectDistrict === val) {
          for (let a = 0; a < DistrictJson.length; a++) {
            const element1 = DistrictJson[a]
            if (element1.Id === element.selectDistrict) {
              this.info.CustomItemList[index].selectDistrictName = element1.DisName
              break
            }
          }
        }
      }
    },
    checkPhoneOrEmail () {
      this.initRoles()
      if (this.$refs.form.validate()) {
        this.$http({
          requestBase: 'VUE_APP_API',
          method: 'post',
          url: '/SignUp/CheckIsExistsUserPhone',
          params: {
            SignUpId: this.info.SignUpId,
            UserSignUpId: 0,
            Phone: this.phone
          }
        }).then(res => {
          console.log(res.data)
          if (res.data.ret === 0) {
            this.submit()
          } else {
            this.loading = false
            this.msg = res.data.msg
            this.snackbar = true
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    teamEditItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.teamDialog = true
    },
    teamDeleteItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.teamDialogDelete = true
    },
    teamDeleteItemConfirm () {
      this.desserts.splice(this.editedIndex, 1)
      this.teamCloseDelete()
    },

    teamClose () {
      this.teamDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    teamCloseDelete () {
      this.teamDialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.paixu()
      })
    },

    teamSave () {
      if (this.$refs.form2.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.teamClose()
        this.paixu()
      }
    },
    paixu () {
      for (let index = 0; index < this.desserts.length; index++) {
        this.desserts[index].num = index + 1
      }
    },
    getMemberList () {
      const ml = []
      for (let index = 0; index < this.desserts.length; index++) {
        const item = this.desserts[index]
        ml.push({
          TrueName: item.name,
          Phone: item.phone.indexOf('@') === -1 ? item.phone : '',
          Email: item.phone.indexOf('@') !== -1 ? item.phone : ''
        })
      }
      return ml
    }
  }
}
</script>
